import { useState } from "react";
import { Sider } from "@refinedev/antd";

import { MainSider } from "./top";
import { CMSSider } from "./inner";

export const CustomSider: typeof Sider = ({ render }) => {
    const [siderKey, setSiderKey] = useState<string>("main");

    return (siderKey === "main" ?
        <MainSider setSiderKey={setSiderKey} /> :
        <CMSSider setSiderKey={setSiderKey} />
    );
};